// Vendor
import { Component, OnInit } from "@angular/core";
import { Router, NavigationExtras, ActivatedRoute } from "@angular/router";
import { FormGroup, FormControl, Validators, AbstractControl } from "@angular/forms";
import { timer } from "rxjs";
import { debounce, tap } from "rxjs/operators";

// App
import { OrderService } from "../../services/order/order.service";
import { PATH_STEP_3 } from "../../app-routing.constants";
import { OrderIsolationTypes } from "../../services/order/order-isolation-types";

@Component({
    selector: "ig-step1",
    templateUrl: "./step1.component.html",
    styleUrls: ["./step1.component.scss"],
})
export class Step1Component implements OnInit {

    isolationTypePreselected = false;

    // I know, little dirty solution
    public form = new FormGroup({
        isolationType1: new FormControl(
            this.orderService.order.isolationType1,
        ),
        isolationType2: new FormControl(
            this.orderService.order.isolationType2,
        ),
        isolationType3: new FormControl(
            this.orderService.order.isolationType3,
        ),
        isolationType4: new FormControl(
            this.orderService.order.isolationType4,
        ),
        isolationType5: new FormControl(
            this.orderService.order.isolationType5,
        ),
    });

    public OrderIsolationTypes = OrderIsolationTypes;

    constructor(
        public router: Router,
        public activatedRoute: ActivatedRoute,
        public orderService: OrderService,
    ) {
    }

    get minYear() {
        return 1500;
    }

    get maxYear() {
        return (new Date()).getUTCFullYear();
    }

    ngOnInit() {
        this.orderService.updateTotal();
        this.form.valueChanges
            .pipe(tap(values => this.orderService.saveValues(values)))
            .pipe(debounce(() => timer(500)))
            .subscribe(_ => this.orderService.updateTotal());

        this.activatedRoute.queryParamMap.subscribe(queryParamMap => {
            const isolationType = queryParamMap.get("isolationType");
            const controls: [string, AbstractControl][] = [
                ["1", this.form.controls["isolationType1"]],
                ["2", this.form.controls["isolationType2"]],
                ["3", this.form.controls["isolationType3"]],
                ["4", this.form.controls["isolationType4"]],
                ["5", this.form.controls["isolationType5"]],
            ];

            const preSelected = controls.find(([t]) => t === isolationType);

            if (preSelected) {
                this.isolationTypePreselected = true;
                controls.forEach(([t, control]) => {
                    control.patchValue(t === isolationType);
                });
            }
        });
    }

    public onNextButtonClick($event: Event) {
        const commands = [];
        const navigationExtras: NavigationExtras = {
            replaceUrl: true,
            queryParamsHandling: "merge",
        };

        this.orderService.order.step1Completed = true;
        this.orderService.order.step2Completed = true;

        commands.push(PATH_STEP_3);

        this.router.navigate(commands, navigationExtras);
    }

    public hasIsolationType() {
        return this.form.controls.isolationType1.value ||
            this.form.controls.isolationType2.value ||
            this.form.controls.isolationType3.value ||
            this.form.controls.isolationType4.value ||
            this.form.controls.isolationType5.value;
    }
}
